import React from "react";
import { ExchangeOthers } from "../Components";

export const ExchangeWithOtherItems = () => {
  return <ExchangeOthers />;
};
